import { RootState } from '@/state/store';

const getLoanableAmounts = (state: RootState) => state.loanableAmounts.getLoanableAmounts.entities;

export default {
  getLoanableAmounts,
};
